/**
 * @Author: Zewei
 * @Date:   2018-01-19T13:54:55+08:00
 * @Last modified by:   Zewei
 * @Last modified time: 2018-01-19T17:45:54+08:00
 */
 import 'rc-drawer-menu/assets/index.css';
 import React from 'react';
 import DrawerMenu from 'rc-drawer-menu';
 import SiderMenu from './SiderMenu';

 export default props => (
   props.isMobile ? (
     <DrawerMenu
       parent={null}
       level={null}
       iconChild={null}
       open={!props.collapsed}
       onMaskClick={() => { props.onCollapse(true); }}
       width="256px"
     >
       <SiderMenu {...props} collapsed={props.isMobile ? false : props.collapsed} />
     </DrawerMenu>
   )
   :
   <SiderMenu {...props} />
 );



// WEBPACK FOOTER //
// ./src/components/SiderMenu/index.js